module.exports = __webpack_public_path__ + "img/border-outer.e774df13.svg";